var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M12 3C7.05469 3 3 7.05469 3 12C3 16.9453 7.05469 21 12 21C16.9453 21 21 16.9453 21 12C21 7.05469 16.9453 3 12 3ZM12 4.5V19.5C7.87207 19.5 4.5 16.1279 4.5 12C4.5 7.87207 7.87207 4.5 12 4.5Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }